import { useState, useMemo, useCallback, useEffect, useContext } from "react";
import {
    Box,
    Stack,
    Typography,
    Card,
    Grid,
    CardContent,
    Avatar,
} from "@mui/material";
import { useGridApiRef, getGridStringOperators } from "@mui/x-data-grid";
import Chart from "../../components/Chart"
import NodataImg from "../../assets/images/noData.png";
import { useDispatch, useSelector } from "react-redux";
import { TeacherLoungeApi } from "../../store/analytics/teacherLounge";
import { ThemeContext } from '../../context/ThemeContext';
import dayjs from "dayjs";
import CustomGridToolbar from "../../components/CustomGridToolbar";
import apiRoutes from "../../store/apiConfigs";
import BackdropUI from "../../ui/Backdrop";
import DataGridComponent from "../../components/DataGridComponent";
import { AiOutlineBell } from 'react-icons/ai'


const TeacherLoungeColumns = [
    {
        field: "id",
        disableColumnMenu: true,
        headerName: "ID",
        width: 120,
        filterable: false,
        sortable: true,
    },
    {
        field: "user_id",
        disableColumnMenu: true,
        headerName: "User ID",
        width: 200,
        filterable: true,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
    },
    {
        field: "user_fullname",
        disableColumnMenu: true,
        headerName: "User Fullname",
        width: 250,
        filterable: true,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
    },
    {
        field: "user_profile_image",
        disableColumnMenu: true,
        headerName: "User Profile Image",
        width: 160,
        filterable: false,
        sortable: false,
        renderCell: (params) => (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                <Avatar src={params.value} alt="User Profile Image" sx={{ width: 40, height: 40 }} />
            </Box>
        ),
    },
    {
        field: "post_type",
        disableColumnMenu: true,
        headerName: "Post Type",
        width: 180,
        filterable: true,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
    },
    {
        field: "youtube_link",
        disableColumnMenu: true,
        headerName: "YouTube Link",
        width: 250,
        filterable: false,
        sortable: false,
    },
    {
        field: "image",
        disableColumnMenu: true,
        headerName: "Image",
        width: 250,
        filterable: false,
        sortable: false,
        renderCell: (params) => {
            return (
                params.value &&
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                    <img
                        src={params.value}
                        alt=""
                        width={100}
                        height={100}
                    />
                </Box>
            )
        },
    },
    {
        field: "thumbnail",
        disableColumnMenu: true,
        headerName: "Thumbnail",
        width: 250,
        filterable: false,
        sortable: false,
    },
    {
        field: "description",
        disableColumnMenu: true,
        headerName: "Description",
        width: 300,
        filterable: true,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
    },
    {
        field: "post_approval",
        disableColumnMenu: true,
        headerName: "Post Approval",
        width: 180,
        filterable: true,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals"
        ),
        sortable: false,
    },
    {
        field: "visibility",
        disableColumnMenu: true,
        headerName: "Visibility",
        width: 180,
        filterable: true,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
    },
    {
        field: "created_at",
        disableColumnMenu: true,
        headerName: "Created At",
        width: 220,
        filterable: true,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: true,
        renderCell: (data) => (<>
            <Typography sx={{ overflowWrap: "anywhere" }}>{data?.row?.created_at && dayjs(data?.row?.created_at).format("YYYY-MM-DD")}</Typography>
        </>),
    },
    {
        field: "like_count",
        disableColumnMenu: true,
        headerName: "Like Count",
        width: 150,
        filterable: false,
        sortable: true,
    },
    {
        field: "comment_count",
        disableColumnMenu: true,
        headerName: "Comment Count",
        width: 160,
        filterable: false,
        sortable: true,
    },
    {
        field: "share_count",
        disableColumnMenu: true,
        headerName: "Share Count",
        width: 160,
        filterable: false,
        sortable: true,
    },
    {
        field: "Edit time",
        disableColumnMenu: true,
        headerName: "Edit Time",
        width: 220,
        filterable: false,
        sortable: true,
        renderCell: (data) => (<>
            <Typography sx={{ overflowWrap: "anywhere" }}>{data?.row?.['Edit time'] && dayjs(data?.row?.['Edit time']).format("YYYY-MM-DD HH:mm:ss")}</Typography>
        </>)
    },
];



export default function TeacherLounge({ graphData, region, state, loading, type, module, monthDaily, startDate, endDate, isMaskingEnabled, schoolType, platform, userType }) {
    const [activevsavgtimespent, setActiveVsAvgTimeSpent] = useState({ l1: true, l2: true });
    const [teacherRegister, setTeacherRegistration] = useState({ l1: true, l2: true, l3: true, l4: true });
    const apiRef = useGridApiRef();
    const dispatch = useDispatch();
    const [isDownload, setIsDownload] = useState(false)
    const TeacherLoungeTable = useSelector((state) => state?.teacherLoungeTable);
    const { result: tableResult, loading: tableLoading, total } = TeacherLoungeTable;
    const teacherLoungeGraphState = useSelector((state) => state?.teacherLoungeGraph);
    const { result: graphResult } = teacherLoungeGraphState || {};
    const [queryOptions, setQueryOptions] = useState({});
    const { paginationModel, setPaginationModel } = useContext(ThemeContext)

    const onFilterChange = useCallback((filterModel) => {
        setQueryOptions({ filterModel: { ...filterModel } });
    }, []);
    const toggleTeacherRegistration = useCallback((key) => {
        setTeacherRegistration(prevState => ({ ...prevState, [key]: !prevState[key] }));
    }, []);
    const toggleActiveVsAvgTimeSpent = useCallback((key) => {
        setActiveVsAvgTimeSpent(prevState => ({ ...prevState, [key]: !prevState[key] }));
    }, []);
    const getRowSpacing = useCallback((params) => {
        return {
            top: params.isFirstVisible ? 0 : 5,
            bottom: params.isLastVisible ? 0 : 5,
        };
    }, []);
    const handleSortModelChange = useCallback((sortModel) => {
        setQueryOptions({ sortModel: [...sortModel] });
    }, []);

    const transformGraphData = useMemo(() => {
        const sourceData = Array.isArray(graphResult?.data) ? graphResult.data : (Array.isArray(graphResult) ? graphResult : []);
        return sourceData.map(item => {
            let roleStr = item.role || item.name || '';
            const parsedName = roleStr ? roleStr.charAt(0).toUpperCase() + roleStr.slice(1) : '';
            return {
                name: parsedName,
                "No. of Posts": item.post_count || 0,
                "Unique users (who have posted)": item.unique_users || 0,
            }
        });
    }, [graphResult]);

    useEffect(() => {
        // console.log("isMaskingEnabled",isMaskingEnabled);
        const filterModel = queryOptions?.filterModel;
        const items = filterModel?.items;
        const firstItem = items && items.length > 0 ? items[0] : {};
        const quickFilterValues = filterModel?.quickFilterValues;
        const sortModel = queryOptions?.sortModel;
        let query
        if (sortModel?.length > 0) {
            query = {
                module_type: module,
                school_type: schoolType,
                page: paginationModel?.page + 1,
                page_size: paginationModel?.pageSize,
                sort_order: sortModel[0].sort || "desc",
                field: firstItem.field || '',
                operator: firstItem.operator || (quickFilterValues && "contains") || '',
                value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
            };
        } else {
            query = {
                module_type: module,
                school_type: schoolType,
                page: paginationModel?.page + 1,
                page_size: paginationModel?.pageSize,
                field: firstItem.field || '',
                region: region,
                sort_order: "desc",
                state: state,
                start_date: startDate,
                end_date: endDate,
                role: userType,
                operator: firstItem.operator || (quickFilterValues && "contains") || '',
                value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
            };
        }
        dispatch(TeacherLoungeApi(query));
    }, [dispatch, queryOptions, paginationModel, region, state, module, startDate, endDate, isMaskingEnabled, schoolType, userType]);


    return (
        <>
            <Stack direction="row" spacing={1} sx={{ my: 2, padding: "10px" }} alignItems="center" justifyContent={"space-between"}>
                <Typography variant="h3">Teacher Lounge</Typography>
            </Stack>
            {/* <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
                <Grid container spacing={1}>
                    {graphData?.total_data && Object.entries(graphData.total_data).map(([data, value], index) => {
                        return (
                            <Grid item xs={6} sm={6} md={6} lg={3} mb={1} key={index}>
                                <Box
                                    className='customCard1'
                                    sx={{
                                        transition: 'none !important',
                                        '&:hover': {
                                            transform: 'none !important',
                                        },
                                    }}
                                >
                                    <Stack direction='row' alignItems='center' spacing={1}>
                                        <Box sx={{ fontSize: 25 }}>
                                            <AiOutlineBell size={25} />
                                        </Box>
                                        <Stack>
                                            <Typography sx={{ textTransform: "capitalize" }}>{data.replaceAll("_", " ")}</Typography>
                                            <Typography variant='h4' fontWeight={600}>{value}</Typography>
                                        </Stack>
                                    </Stack>
                                </Box>
                            </Grid>
                        )
                    })}
                </Grid>
            </Stack> */}
            {/* <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
                <Chart type={"line"} height={500} data={transformGraphData} module={'CourseProgress'} lineState={teacherRegister} />
            </Stack> */}

            {(transformGraphData && transformGraphData.length > 0) && (
                <Stack direction="row" spacing={1} sx={{ my: 2, padding: "10px" }} alignItems="center">
                    <Card sx={{ width: '100%' }}>
                        <CardContent>
                            <Chart type={"bar"} height={400} data={transformGraphData} module={'TeacherLoungeGraph'} />
                        </CardContent>
                    </Card>
                </Stack>
            )}

            <Stack direction="row" spacing={1} sx={{ my: 2, padding: "10px" }} alignItems="center">
                <DataGridComponent
                    disableColumnMenu
                    disableColumnSorting
                    loading={tableLoading}
                    rowCount={total}
                    pageSize={paginationModel?.pageSize}
                    onPageSizeChange={(newPageSize) => {
                        setPaginationModel({
                            ...paginationModel,
                            pageSize: newPageSize,
                        })
                    }}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    sx={{
                        height: 500
                    }}
                    rows={tableResult || []}
                    getRowId={(row) => row.id}
                    getRowSpacing={getRowSpacing}
                    columns={TeacherLoungeColumns}
                    onSortModelChange={handleSortModelChange}
                    onFilterModelChange={onFilterChange}
                    slots={{
                        noRowsOverlay: () => (
                            <Box className="noData">
                                <img src={NodataImg} alt="no data found" />
                            </Box>
                        ),
                        toolbar: (props) =>
                        (CustomGridToolbar({
                            ...props, moduleType: "TeacherLounge",
                            queryOptions: queryOptions,
                            paginationModel: paginationModel,
                            isDownload: isDownload,
                            setIsDownload: setIsDownload,
                            apiUrl: apiRoutes.teacherLoungeCsvExport,
                            hasfilter: false,
                            hasSearch: false,
                            additionalQueryParams: {
                                role: userType,
                                region: region,
                                state: state,
                                ...(startDate !== undefined && { start_date: startDate }),
                                ...(endDate !== undefined && { end_date: endDate }),
                            }
                        })),
                    }}
                    slotProps={{
                        loadingOverlay: {
                            variant: 'linear-progress',
                            noRowsVariant: 'linear-progress',
                        },
                        toolbar: {
                            showQuickFilter: true,
                        },
                    }}
                />
            </Stack>
            <BackdropUI open={isDownload} />
        </>)
}

